import React from "react";
import "./errorPages.css";
import pageNotFoundImage from "../../../Assets/Images/Illustrations/404page.svg"
import Button from "../../BasicComponents/Button";
import MetaData from "../../MetaData/MetaData";

class ErrorPages extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            route: ""
        }
    }

    render() {
        return (
            <div className="error-page-layout">
                <MetaData keyword={"404"}/>
                <div className="error-page-container">
                    <div className="error-page-text_container">
                        <h1 className="error-page-header-text">
                           Sorry, We couldn't find that page
                        </h1>
                        <div className="error-page-content">
                            The page you are looking for might have been removed, had its name changed or is temporarily unavailable.
                        </div>
                        <div className="error-page-button-container">
                            <Button type={"buttonLink"} linkedRoute={"/"}>
                                Home
                            </Button>

                        </div>
                    </div>
                    <div className="error-page-image-container">
                        <img src={pageNotFoundImage}
                             alt={"404 Page Not Found"}
                             width={"100%"}
                             className="error-page-logo-dd"/>
                    </div>

                </div>

            </div>
        );
    }

}

export default ErrorPages;